import { createApp } from 'vue'
import { createPinia } from 'pinia'
import piniaPluginPersistedstate from 'pinia-plugin-persistedstate'
import App from './App.vue'
import router from '@/router'
import ElementPlus from 'element-plus'
import 'element-plus/dist/index.css'
import notify from '@/utils/notify'

import * as ElementPlusIconsVue from '@element-plus/icons-vue'
import apiPlugin from "@/plugins/apiPlugin"

const catchHttpError = function (error) {
    if(!error){
        throw new Error('Error is not defined')
    }
    if(error.code === 'ECONNABORTED'){
        throw new Error('Request timeout')
    }
    notify.error(error.message, { duration: 5000 })
}

// Create Pinia with persistence
const pinia = createPinia()
pinia.use(piniaPluginPersistedstate)

const app = createApp(App)

// Register icons
for (const [key, component] of Object.entries(ElementPlusIconsVue)) {
    app.component(key, component)
}

// Install plugins in correct order
app.use(pinia)
app.use(apiPlugin)
app.use(ElementPlus)
app.use(router)

app.provide('$catchHttpError', catchHttpError)

app.mount('#app')